import emojiData from '@emoji-mart/data/sets/15/native.json';

const shortcodePattern = /:([a-zA-Z0-9_+-]+):(?::skin-tone-([2-6]):)?/g;
const discourseEmojiAliases: Record<string, string> = {
  slight_smile: 'slightly_smiling_face',
};

export const replaceDiscourseEmojiShortcodes = (value?: string | null): string => {
  if (!value) {
    return '';
  }

  return value.replace(shortcodePattern, (shortcode, name: string, tone?: string) => {
    const normalizedName = name.toLowerCase().replace(/-/g, '_');
    const emojiId = discourseEmojiAliases[normalizedName]
      || emojiData.aliases[normalizedName]
      || normalizedName;
    const skins = emojiData.emojis[emojiId]?.skins;
    const skinIndex = tone ? Number(tone) - 1 : 0;
    return skins?.[skinIndex]?.native || skins?.[0]?.native || shortcode;
  });
};
